<template>
  <d-list-group flush>
    <d-list-group-item class="p-3">
      <d-row>
        <d-col>
          <d-form @submit.prevent="save" :validated="hasErrors">
            <d-form-row>
              <!-- Nome -->
              <d-col md="6" class="form-group">
                <label for="feName">Nome</label>
                <d-form-input
                  type="text"
                  id="feName"
                  placeholder="Nome"
                  v-model="model.name"
                  :state="hasErrorField('name')"
                />
                <d-form-invalid-feedback>
                  Nome é obrigatório
                </d-form-invalid-feedback>
              </d-col>

              <!-- E-mail -->
              <d-col md="6" class="form-group">
                <label for="feContactEmail">E-mail</label>
                <d-form-input
                  type="email"
                  id="feContactEmail"
                  placeholder="E-mail"
                  v-model="model.email"
                  :state="hasErrorField('email')"
                />
                <d-form-invalid-feedback>
                  {{ invalidFeedbackEmail('email') }}
                </d-form-invalid-feedback>
              </d-col>
            </d-form-row>
          </d-form>
        </d-col>
      </d-row>
    </d-list-group-item>
  </d-list-group>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import mixin from '_common/mixins/ValidateForm';
import { CloneDeep } from '_utils';
import { MODEL, _LOAD_MODEL_ } from './SupervisorModel';

export default {
  name: 'supervisor-form',
  mixins: [mixin],
  data() {
    return {
      model: CloneDeep(MODEL),
      errors: {
        name: { required: false },
        email: { required: false, isEmail: false },
      },
    };
  },
  computed: {
    isAdmin() {
      const { isAdmin } = this.$store.state.user;
      return isAdmin;
    },
  },
  methods: {
    ...mapActions(['activeAlert', 'checkAdmin', 'editSupervisor']),
    save() {
      if (this.checkForm()) {
        return this.editSupervisor(this.model)
          .then(() => {
            this.success();
          })
          .catch(error => {
            this.activeAlert({
              message: `${error.message} <br/> ${error.data}`,
              theme: 'danger',
            });
          });
      }

      return null;
    },
    success() {
      this.activeAlert({
        message: 'Supervisor editado com sucesso',
        theme: 'success',
      });
      this.$router.push('/admin/supervisores/lista/1');
    },
    setSupervisor(newValue) {
      this.model = newValue;
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$on(_LOAD_MODEL_, this.setSupervisor);
  },
  destroyed() {
    Events.$off(_LOAD_MODEL_);
  },
};
</script>
